import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=3462f357&scoped=true&"
import script from "./homeFooter.vue?vue&type=script&lang=js&"
export * from "./homeFooter.vue?vue&type=script&lang=js&"
import style0 from "./homeFooter.vue?vue&type=style&index=0&id=3462f357&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3462f357",
  null
  
)

export default component.exports